import { registeredMark } from '../../documents/disclosures/regulatory';
var menus = [{
  id: 'rpt',
  tabName: 'Credit',
  dataLinkBoth: 'nav-public-header-credit',
  adviceTitle: 'Credit advice',
  drpMainCategories: [{
    advice: {
      mobileTitle: 'Most popular',
      links: [{
        title: 'What is a good credit score?',
        link: '/blogs/ask-experian/credit-education/score-basics/what-is-a-good-credit-score/',
        linkType: 'blog'
      }, {
        title: 'Credit score ranges',
        link: '/blogs/ask-experian/infographic-what-are-the-different-scoring-ranges/',
        linkType: 'blog'
      }, {
        title: 'Average credit score in the U.S.',
        link: '/blogs/ask-experian/what-is-the-average-credit-score-in-the-u-s/',
        linkType: 'blog'
      }, {
        title: 'Improving your credit',
        link: '/blogs/ask-experian/credit-education/improving-credit/improve-credit-score/',
        linkType: 'blog'
      }, {
        title: 'How to build credit',
        link: '/blogs/ask-experian/credit-education/improving-credit/building-credit/',
        linkType: 'blog'
      }, {
        title: 'What is a credit bureau?',
        link: '/blogs/ask-experian/what-is-a-credit-bureau/',
        linkType: 'blog'
      }, {
        title: 'Freeze your credit at all 3 credit bureaus',
        link: '/blogs/ask-experian/credit-education/preventing-fraud/security-freeze/',
        linkType: 'blog'
      }, {
        title: 'How credit utilization impacts credit',
        link: '/blogs/ask-experian/how-long-will-high-credit-utilization-hurt-credit-score/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit/credit-report/',
    title: 'Free credit report',
    linkType: 'product',
    subcopy: 'See your latest credit information',
    icon: 'ecs-font-icon-frs-report-experian',
    advice: {
      mobileTitle: 'Credit reports',
      links: [{
        title: 'How to remove credit inquiries',
        link: '/blogs/ask-experian/how-to-remove-hard-inquiries-from-credit-report/',
        linkType: 'blog'
      }, {
        title: 'Collections on your credit report',
        link: '/blogs/ask-experian/credit-education/report-basics/how-and-when-collections-are-removed-from-a-credit-report/',
        linkType: 'blog'
      }, {
        title: 'What is a charge-off?',
        link: '/blogs/ask-experian/what-is-a-charge-off/',
        linkType: 'blog'
      }, {
        title: 'How bankruptcy works',
        link: '/blogs/ask-experian/credit-education/bankruptcy-how-it-works-types-and-consequences/',
        linkType: 'blog'
      }, {
        title: 'Get credit reports from all 3 credit bureaus',
        link: '/blogs/ask-experian/credit-education/report-basics/my-credit-report/',
        linkType: 'blog'
      }, {
        title: 'Check your credit report and file disputes',
        link: '/blogs/ask-experian/how-to-check-credit-report-and-file-disputes/',
        linkType: 'blog'
      }, {
        title: 'How to remove a paid collection',
        link: '/blogs/ask-experian/how-do-i-get-a-paid-collection-off-my-credit-report/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit/credit-score/',
    title: 'Free credit score',
    linkType: 'product',
    subcopy: "Get to know your FICO".concat(registeredMark, " Score"),
    icon: 'ecs-font-icon-frs-score',
    advice: {
      mobileTitle: 'Credit scores',
      links: [{
        title: 'Impact of paying off a credit card',
        link: '/blogs/ask-experian/how-long-after-paying-off-a-credit-card-will-my-credit-score-go-up/',
        linkType: 'blog'
      }, {
        title: 'Reasons to have a good credit score',
        link: '/blogs/ask-experian/why-would-you-want-a-good-credit-score/',
        linkType: 'blog'
      }, {
        title: 'Does checking credit score lower it?',
        link: '/blogs/ask-experian/does-checking-your-credit-score-lower-it/',
        linkType: 'blog'
      }, {
        title: 'What is a perfect credit score?',
        link: '/blogs/ask-experian/perfect-scores-who-has-them-and-what-do-they-have-in-common/',
        linkType: 'blog'
      }, {
        title: 'Different types of credit scores',
        link: '/blogs/ask-experian/what-is-the-difference-between-fico-score-and-credit-score/',
        linkType: 'blog'
      }, {
        title: 'What factors affect your credit score?',
        link: '/blogs/ask-experian/credit-education/score-basics/what-affects-your-credit-scores/',
        linkType: 'blog'
      }, {
        title: "How the FICO".concat(registeredMark, " Score Simulator works"),
        link: '/blogs/ask-experian/how-does-credit-score-simulator-work/',
        linkType: 'blog'
      }, {
        title: 'Why did your credit score drop?',
        link: '/blogs/ask-experian/why-did-my-credit-score-drop/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit/score-boost/',
    title: "Experian Boost".concat(registeredMark),
    linkType: 'product',
    subcopy: 'Raise your credit scores instantly',
    icon: 'ecs-font-icon-frs-rocket-boost',
    advice: {
      mobileTitle: 'Improving credit',
      links: [{
        title: 'Reasons your credit score isn’t increasing',
        link: '/blogs/ask-experian/reasons-your-credit-score-isnt-increasing/',
        linkType: 'blog'
      }, {
        title: 'Will credit improve after debt payoff?',
        link: '/blogs/ask-experian/how-long-after-you-pay-off-debt-does-your-credit-improve/',
        linkType: 'blog'
      }, {
        title: 'Does a mortgage hurt your credit score?',
        link: '/blogs/ask-experian/does-mortgage-hurt-credit-score/',
        linkType: 'blog'
      }, {
        title: 'How to build credit with credit cards',
        link: '/blogs/ask-experian/how-to-use-a-credit-card-to-build-credit/',
        linkType: 'blog'
      }, {
        title: 'How to repair your credit',
        link: '/blogs/ask-experian/how-to-repair-credit/',
        linkType: 'blog'
      }, {
        title: 'What is Experian Boost?',
        link: '/blogs/ask-experian/what-is-experian-boost/',
        linkType: 'blog'
      }, {
        title: 'How utility bills can boost your credit',
        link: '/blogs/ask-experian/does-paying-utility-bills-help-your-credit-score/',
        linkType: 'blog'
      }, {
        title: 'How often a credit report is updated',
        link: '/blogs/ask-experian/credit-information-is-updated-continuously/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit/experian-go/',
    title: 'Experian Go™',
    linkType: 'product',
    subcopy: 'Establish and build your credit',
    icon: 'ecs-font-icon-frs-chart-grow',
    advice: {
      mobileTitle: 'Establishing credit',
      links: [{
        title: 'How to build credit with no credit history',
        link: '/blogs/ask-experian/how-to-build-credit-with-no-credit-history/',
        linkType: 'blog'
      }, {
        title: 'How to establish credit',
        link: '/blogs/ask-experian/how-to-establish-credit-as-a-young-person/',
        linkType: 'blog'
      }, {
        title: 'How to get first-time credit',
        link: '/blogs/ask-experian/how-can-i-get-credit-for-the-first-time/',
        linkType: 'blog'
      }, {
        title: 'How to get credit with no credit history',
        link: '/blogs/ask-experian/how-to-get-a-credit-card-if-you-dont-have-a-credit-history/',
        linkType: 'blog'
      }, {
        title: 'Credit mistakes to avoid',
        link: '/blogs/ask-experian/common-credit-mistakes-to-avoid/',
        linkType: 'blog'
      }, {
        title: 'How long does it take to build credit?',
        link: '/blogs/ask-experian/how-long-does-it-take-to-build-credit/',
        linkType: 'blog'
      }, {
        title: 'How credit history affects your credit',
        link: '/blogs/ask-experian/length-of-credit-history-affect-credit-scores/',
        linkType: 'blog'
      }, {
        title: 'Credit cards for no credit',
        link: '/blogs/ask-experian/what-is-the-easiest-credit-card-to-get-with-no-credit/',
        linkType: 'blog'
      }]
    }
  }],
  drpTabFixed: {
    title: 'Credit support',
    links: [{
      title: 'Security freeze',
      link: '/help/credit-freeze/',
      linkType: 'product'
    }, {
      title: 'Disputes',
      link: '/disputes/main.html'
    }, {
      title: 'Fraud alert',
      link: '/help/fraud-alert/',
      linkType: 'product'
    }, {
      title: 'Contact us',
      link: '/contact/personal-services-contacts.html'
    }]
  }
}, {
  id: 'itp',
  tabName: 'Protection',
  dataLinkBoth: 'nav-public-header-protection',
  adviceTitle: 'Identity Theft Advice',
  drpMainCategories: [{
    advice: {
      mobileTitle: 'Most popular',
      links: [{
        title: 'What is identity theft?',
        link: '/blogs/ask-experian/what-is-identity-theft/',
        linkType: 'blog'
      }, {
        title: 'Fraud alert and credit freeze differences',
        link: '/blogs/ask-experian/what-is-the-difference-between-a-credit-freeze-and-fraud-alert/',
        linkType: 'blog'
      }, {
        title: 'Remove fraud from your credit report',
        link: '/blogs/ask-experian/how-to-remove-fraud-information-from-credit-report/',
        linkType: 'blog'
      }, {
        title: 'Identity theft statistics',
        link: '/blogs/ask-experian/identity-theft-statistics/',
        linkType: 'blog'
      }, {
        title: 'What are the latest scams?',
        link: '/blogs/ask-experian/the-latest-scams-you-need-to-aware-of/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/protection/identity-theft-and-credit-protection/',
    title: 'Identity theft and fraud',
    subcopy: 'ID monitoring, alerts and protection',
    icon: 'ecs-font-icon-idt-shield-lock',
    advice: {
      mobileTitle: 'Identity theft and fraud',
      links: [{
        title: 'How to check for identity theft',
        link: '/blogs/ask-experian/how-do-you-check-for-identity-theft/',
        linkType: 'blog'
      }, {
        title: 'What if your Social Security number is stolen?',
        link: '/blogs/ask-experian/3-steps-to-take-if-your-social-security-number-has-been-stolen/',
        linkType: 'blog'
      }, {
        title: 'How to avoid identity theft',
        link: '/blogs/ask-experian/credit-education/preventing-fraud/',
        linkType: 'blog'
      }, {
        title: 'Types of identity theft',
        link: '/blogs/ask-experian/20-types-of-identity-theft-and-fraud/',
        linkType: 'blog'
      }, {
        title: 'How to protect your identity',
        link: '/blogs/ask-experian/how-to-protect-yourself-from-identity-theft/',
        linkType: 'blog'
      }, {
        title: 'What is a fraud alert?',
        link: '/blogs/ask-experian/what-is-a-fraud-alert/',
        linkType: 'blog'
      }, {
        title: 'Do fraud alerts expire?',
        link: '/blogs/ask-experian/do-fraud-alerts-expire/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/protection/free-dark-web-email-scan/',
    title: 'Free dark web scan',
    subcopy: 'Scan for your SSN, phone and email',
    icon: 'ecs-font-icon-idt-dark-web',
    advice: {
      mobileTitle: 'Cybersecurity',
      links: [{
        title: 'What is the dark web?',
        link: '/blogs/ask-experian/what-is-the-dark-web/',
        linkType: 'blog'
      }, {
        title: 'What is dark web monitoring?',
        link: '/blogs/ask-experian/what-is-dark-web-monitoring/',
        linkType: 'blog'
      }, {
        title: 'What to do about a data breach',
        link: '/blogs/ask-experian/data-breach-five-things-to-do-after-your-information-has-been-stolen/',
        linkType: 'blog'
      }, {
        title: 'Protect your information from the dark web',
        link: '/blogs/ask-experian/what-to-do-if-information-is-found-on-dark-web/',
        linkType: 'blog'
      }, {
        title: 'Tips for victims of credit card fraud',
        link: '/blogs/ask-experian/credit-education/preventing-fraud/credit-card-fraud-what-to-do-if-you-are-a-victim/',
        linkType: 'blog'
      }, {
        title: 'What is a VPN?',
        link: '/blogs/ask-experian/what-is-a-vpn/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/protection/personal-privacy-scan/',
    title: 'Free personal privacy scan',
    subcopy: 'Find your info on people finder sites',
    icon: 'ecs-font-icon-ppl-user-data',
    advice: {
      mobileTitle: 'Privacy',
      links: [{
        title: 'How to protect your info online',
        link: '/blogs/ask-experian/how-do-you-protect-your-personal-information-online/',
        linkType: 'blog'
      }, {
        title: 'Remove your info from people search sites',
        link: '/blogs/ask-experian/how-to-remove-your-information-from-people-search-sites/',
        linkType: 'blog'
      }, {
        title: 'How to get off robocall lists',
        link: '/blogs/ask-experian/how-to-remove-your-name-from-robocall-lists/',
        linkType: 'blog'
      }, {
        title: 'Social media safety tips',
        link: '/blogs/ask-experian/9-ways-to-stay-safe-on-social-media/',
        linkType: 'blog'
      }, {
        title: 'Identity thieves and your personal info',
        link: '/blogs/ask-experian/what-can-identity-thieves-do-with-your-personal-information-and-how-can-you-protect-yourself/',
        linkType: 'blog'
      }, {
        title: 'How to keep your SSN safe',
        link: '/blogs/ask-experian/how-to-keep-social-security-number-safe/',
        linkType: 'blog'
      }]
    }
  }],
  drpTabFixed: {
    title: 'Identity Theft support',
    links: [{
      title: 'Security freeze',
      link: '/help/credit-freeze/',
      linkType: 'product'
    }, {
      title: 'Fraud alert',
      link: '/help/fraud-alert/',
      linkType: 'product'
    }, {
      title: 'Disputes',
      link: '/disputes/main.html'
    }, {
      title: 'Contact us',
      link: '/contact/personal-services-contacts.html'
    }]
  }
}, {
  id: 'mon',
  tabName: 'Money',
  dataLinkBoth: 'nav-public-header-money',
  adviceTitle: 'Money advice',
  drpMainCategories: [{
    advice: {
      mobileTitle: 'Most popular',
      links: [{
        title: 'Best high-yield savings accounts',
        link: '/blogs/ask-experian/best-high-yield-savings-accounts/',
        linkType: 'blog'
      }, {
        title: 'Best CD rates',
        link: '/blogs/ask-experian/best-cd-rates/',
        linkType: 'blog'
      }, {
        title: 'Best money market accounts',
        link: '/blogs/ask-experian/best-money-market-accounts/',
        linkType: 'blog'
      }, {
        title: 'Challenges to help you save money',
        link: '/blogs/ask-experian/savings-challenges-to-try-this-year/',
        linkType: 'blog'
      }, {
        title: 'Can you deposit money at any ATM?',
        link: '/blogs/ask-experian/can-you-deposit-money-at-any-atm/',
        linkType: 'blog'
      }, {
        title: 'Savings accounts that pay high interest',
        link: '/blogs/ask-experian/which-type-of-savings-account-pays-highest-interest-rate/',
        linkType: 'blog'
      }, {
        title: 'Opening a high-yield savings account',
        link: '/blogs/ask-experian/how-to-open-high-yield-savings-account/',
        linkType: 'blog'
      }, {
        title: 'Pros and cons of high-yield savings',
        link: '/blogs/ask-experian/pros-cons-high-yield-savings-account/',
        linkType: 'blog'
      }]
    }
  }, {
    subcopy: 'Check out Experian Smart Money™',
    icon: 'ecs-font-icon-ccm-credit-card',
    link: '/money/experian-smart-money/',
    linkType: 'product',
    title: 'Digital checking account',
    advice: {
      mobileTitle: 'Digital checking account',
      links: [{
        title: 'What is Experian Smart Money?',
        link: '/blogs/ask-experian/what-is-experian-smart-money/',
        linkType: 'blog'
      }, {
        title: 'How do bank account bonuses work?',
        link: '/blogs/ask-experian/how-do-bank-account-bonuses-work/',
        linkType: 'blog'
      }, {
        title: 'Why was I denied a checking account?',
        link: '/blogs/ask-experian/why-was-i-denied-a-checking-account/',
        linkType: 'blog'
      }, {
        title: 'What is a high-yield checking account?',
        link: '/blogs/ask-experian/what-is-high-yield-checking-account/',
        linkType: 'blog'
      }, {
        title: 'Earn cash back with a debit card',
        link: '/blogs/ask-experian/debit-cards-that-offer-cash-back-rewards/',
        linkType: 'blog'
      }, {
        title: 'Pros and cons of premium checking',
        link: '/blogs/ask-experian/pros-cons-premium-checking-account/',
        linkType: 'blog'
      }, {
        title: 'Routing number vs. account number',
        link: '/blogs/ask-experian/what-is-the-difference-between-routing-and-account-numbers/',
        linkType: 'blog'
      }, {
        title: 'Why was my debit card declined?',
        link: '/blogs/ask-experian/why-is-debit-card-declining/',
        linkType: 'blog'
      }]
    }
  }, {
    subcopy: 'We’ll negotiate bills for you & cancel unwanted subscriptions',
    icon: 'ecs-font-icon-idt-report-bank',
    link: '/money/manage-bills-subscriptions/',
    title: 'Manage your expenses',
    linkType: 'product',
    advice: {
      mobileTitle: 'Save money on bills',
      links: [{
        title: 'Tips for spending money wisely',
        link: '/blogs/ask-experian/tips-for-spending-money-wisely/',
        linkType: 'blog'
      }, {
        title: 'How to make a budget',
        link: '/blogs/ask-experian/how-to-make-a-budget/',
        linkType: 'blog'
      }, {
        title: 'Ways to reduce expenses',
        link: '/blogs/ask-experian/how-to-reduce-expenses/',
        linkType: 'blog'
      }, {
        title: 'Ways to plan for unexpected expenses',
        link: '/blogs/ask-experian/how-to-plan-for-unexpected-expenses/',
        linkType: 'blog'
      }, {
        title: 'What is an emergency fund?',
        link: '/blogs/ask-experian/what-is-an-emergency-fund/',
        linkType: 'blog'
      }, {
        title: 'Ways to save money',
        link: '/blogs/ask-experian/how-to-save-money/',
        linkType: 'blog'
      }, {
        title: 'What is a budget?',
        link: '/blogs/ask-experian/what-is-a-budget/',
        linkType: 'blog'
      }, {
        title: 'Why is budgeting important?',
        link: '/blogs/ask-experian/why-is-budgeting-important/',
        linkType: 'blog'
      }]
    }
  }]
}, {
  id: 'crd',
  tabName: 'Credit Cards',
  dataLinkBoth: 'nav-public-header-creditcards',
  adviceTitle: 'Credit Card advice',
  drpMainCategories: [{
    link: '/credit-cards/',
    title: 'All credit card types',
    linkType: 'offers',
    icon: 'ecs-font-icon-ccm-credit-card',
    advice: {
      mobileTitle: 'Most popular',
      links: [{
        title: 'How to pay off credit card debt',
        link: '/blogs/ask-experian/credit-education/how-to-pay-off-credit-card-debt/',
        linkType: 'blog'
      }, {
        title: 'How many credit cards should I have?',
        link: '/blogs/ask-experian/how-many-credit-cards-should-i-have/',
        linkType: 'blog'
      }, {
        title: 'How to use credit cards',
        link: '/blogs/ask-experian/how-to-use-a-credit-card/',
        linkType: 'blog'
      }, {
        title: 'Which credit card should I get?',
        link: '/blogs/ask-experian/what-credit-card-should-i-get/',
        linkType: 'blog'
      }, {
        title: 'What is an APR?',
        link: '/blogs/ask-experian/what-is-apr/',
        linkType: 'blog'
      }, {
        title: 'Average credit card debt',
        link: '/blogs/ask-experian/state-of-credit-cards/',
        linkType: 'blog'
      }, {
        title: 'Credit card payoff calculator',
        link: '/blogs/ask-experian/credit-card-payoff-calculator/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit-cards/best-balance-transfer/',
    title: 'Balance transfer',
    linkType: 'offers',
    icon: 'ecs-font-icon-ccm-balance-transfer',
    advice: {
      mobileTitle: 'Balance transfer',
      links: [{
        title: 'How balance transfers work',
        link: '/blogs/ask-experian/what-is-a-balance-transfer-and-how-does-it-work/',
        linkType: 'blog'
      }, {
        title: 'How long does a balance transfer take?',
        link: '/blogs/ask-experian/how-long-does-a-credit-card-balance-transfer-take/',
        linkType: 'blog'
      }, {
        title: 'What are balance transfer credit cards?',
        link: '/blogs/ask-experian/credit-education/balance-transfer-credit-cards/',
        linkType: 'blog'
      }, {
        title: 'How to do a balance transfer',
        link: '/blogs/ask-experian/how-to-do-a-balance-transfer/',
        linkType: 'blog'
      }, {
        title: 'What is a credit utilization rate?',
        link: '/blogs/ask-experian/credit-education/score-basics/credit-utilization-rate/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit-cards/best-cash-back/',
    title: 'Cash back',
    linkType: 'offers',
    icon: 'ecs-font-icon-ccm-cashback',
    advice: {
      mobileTitle: 'Cash back',
      links: [{
        title: 'How cash back works',
        link: '/blogs/ask-experian/how-do-cash-back-credit-cards-work/',
        linkType: 'blog'
      }, {
        title: 'What is a credit card cash advance fee?',
        link: '/blogs/ask-experian/what-is-credit-card-cash-advance-fee/',
        linkType: 'blog'
      }, {
        title: 'Cash back vs. points',
        link: '/blogs/ask-experian/cash-back-vs-points-which-rewards-credit-card-is-better/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit-cards/best-for-bad-credit/',
    title: 'For bad credit',
    linkType: 'offers',
    icon: 'ecs-font-icon-frs-score-bad',
    advice: {
      mobileTitle: 'For bad credit',
      links: [{
        title: 'Applying for a credit card with bad credit',
        link: '/blogs/ask-experian/how-to-apply-for-a-credit-card-with-bad-credit/',
        linkType: 'blog'
      }, {
        title: 'Balance transfer cards with bad credit',
        link: '/blogs/ask-experian/can-i-get-a-balance-transfer-card-with-bad-credit/',
        linkType: 'blog'
      }, {
        title: 'Getting a credit card after bankruptcy',
        link: '/blogs/ask-experian/can-i-get-a-credit-card-after-bankruptcy/',
        linkType: 'blog'
      }, {
        title: 'Easy store cards to get with bad credit',
        link: '/blogs/ask-experian/what-is-the-easiest-store-card-to-get-with-bad-credit/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit-cards/best-low-interest/',
    title: 'Low interest',
    linkType: 'offers',
    icon: 'ecs-font-icon-frs-chart-down',
    advice: {
      mobileTitle: 'APR',
      links: [{
        title: 'What is a good APR?',
        link: '/blogs/ask-experian/what-is-a-good-apr-for-a-credit-card/',
        linkType: 'blog'
      }, {
        title: 'Lowering your credit card interest rate',
        link: '/blogs/ask-experian/how-to-lower-credit-card-interest-rate/',
        linkType: 'blog'
      }, {
        title: 'Fed interest rate impact on credit cards',
        link: '/blogs/ask-experian/how-do-fed-rate-cuts-impact-credit-cards/',
        linkType: 'blog'
      }, {
        title: 'How much available credit is best?',
        link: '/blogs/ask-experian/how-much-available-credit-should-i-have/',
        linkType: 'blog'
      }, {
        title: 'APR calculator',
        link: '/blogs/ask-experian/apr-calculator/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit-cards/best-rewards/',
    title: 'Rewards',
    linkType: 'offers',
    icon: 'ecs-font-icon-con-rewards-gift',
    advice: {
      mobileTitle: 'Rewards',
      links: [{
        title: 'How to choose a rewards credit card',
        link: '/blogs/ask-experian/how-to-choose-rewards-credit-card/',
        linkType: 'blog'
      }, {
        title: 'Are rewards credit cards worth it?',
        link: '/blogs/ask-experian/are-rewards-cards-worth-it/',
        linkType: 'blog'
      }, {
        title: 'What is a rewards credit card?',
        link: '/blogs/ask-experian/what-is-a-rewards-credit-card/',
        linkType: 'blog'
      }, {
        title: 'Ways to redeem credit card rewards',
        link: '/blogs/ask-experian/best-ways-to-redeem-credit-card-rewards/',
        linkType: 'blog'
      }, {
        title: 'Credit score needed to get a rewards card',
        link: '/blogs/ask-experian/what-credit-score-do-you-need-to-get-a-rewards-card/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/credit-cards/best-secured/',
    title: 'Secured',
    linkType: 'offers',
    icon: 'ecs-font-icon-idt-shield-lock',
    advice: {
      mobileTitle: 'New to credit',
      links: [{
        title: 'What is a secured credit card?',
        link: '/blogs/ask-experian/what-is-a-secured-credit-card/',
        linkType: 'blog'
      }, {
        title: 'How to use a secured credit card',
        link: '/blogs/ask-experian/how-to-use-a-secured-credit-card/',
        linkType: 'blog'
      }, {
        title: 'Secured vs. prepaid credit cards',
        link: '/blogs/ask-experian/secured-card-vs-prepaid-card/',
        linkType: 'blog'
      }, {
        title: 'How to get a secured credit card',
        link: '/blogs/ask-experian/how-to-get-a-secured-credit-card/',
        linkType: 'blog'
      }, {
        title: 'Secured credit card with no deposit',
        link: '/blogs/ask-experian/can-you-get-secured-card-with-no-deposit/',
        linkType: 'blog'
      }, {
        title: 'Can I get an unsecured credit card?',
        link: '/blogs/ask-experian/can-i-get-an-unsecured-credit-card-with-a-500-credit-score/',
        linkType: 'blog'
      }]
    }
  }]
}, {
  id: 'lns',
  tabName: 'Loans',
  dataLinkBoth: 'nav-public-header-loans',
  adviceTitle: 'Loan advice',
  drpMainCategories: [{
    link: '/loans/',
    title: 'All loan types',
    linkType: 'offers',
    icon: 'ecs-font-icon-frs-bank',
    advice: {
      mobileTitle: 'Most popular',
      links: [{
        title: 'What is a personal loan?',
        link: '/blogs/ask-experian/what-is-a-personal-loan/',
        linkType: 'blog'
      }, {
        title: 'Emergency loans with bad credit',
        link: '/blogs/ask-experian/can-i-get-an-emergency-loan-with-bad-credit/',
        linkType: 'blog'
      }, {
        title: 'How to get a personal loan with fair credit',
        link: '/blogs/ask-experian/can-i-get-a-personal-loan-with-fair-credit/',
        linkType: 'blog'
      }, {
        title: 'What is a secured loan?',
        link: '/blogs/ask-experian/what-is-a-secured-loan/',
        linkType: 'blog'
      }, {
        title: 'How do personal loans impact credit?',
        link: '/blogs/ask-experian/how-does-a-personal-loan-impact-your-credit/',
        linkType: 'blog'
      }, {
        title: 'How to get an emergency loan',
        link: '/blogs/ask-experian/emergency-loans-where-to-get-the-best-ones/',
        linkType: 'blog'
      }, {
        title: 'Personal loan calculator',
        link: '/blogs/ask-experian/personal-loan-calculator/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/loans/debt-consolidation/',
    title: 'Debt consolidation',
    linkType: 'offers',
    icon: 'ecs-font-icon-frs-chart-bar',
    advice: {
      mobileTitle: 'Debt consolidation',
      links: [{
        title: 'How to get a loan with bad credit',
        link: '/blogs/ask-experian/how-to-get-a-debt-consolidation-loan-with-bad-credit/',
        linkType: 'blog'
      }, {
        title: 'Personal loans to pay off credit card debt',
        link: '/blogs/ask-experian/should-i-get-a-personal-loan-to-pay-off-my-credit-card/',
        linkType: 'blog'
      }, {
        title: 'Payday loan consolidation',
        link: '/blogs/ask-experian/what-to-know-about-payday-loan-consolidation/',
        linkType: 'blog'
      }, {
        title: 'Is it a good idea to consolidate debt?',
        link: '/blogs/ask-experian/thinking-about-consolidating-debt-good-idea/',
        linkType: 'blog'
      }, {
        title: 'How debt consolidation affects credit',
        link: '/blogs/ask-experian/can-debt-consolidation-affect-your-credit-score/',
        linkType: 'blog'
      }, {
        title: 'What is debt consolidation?',
        link: '/blogs/ask-experian/what-is-debt-consolidation/',
        linkType: 'blog'
      }, {
        title: 'How debt consolidation works',
        link: '/blogs/ask-experian/how-does-a-debt-consolidation-program-work/',
        linkType: 'blog'
      }, {
        title: 'How to get a debt consolidation loan',
        link: '/blogs/ask-experian/how-to-get-a-debt-consolidation-loan/',
        linkType: 'blog'
      }]
    }
  }, {
    link: '/loans/personal/',
    title: 'Personal',
    linkType: 'offers',
    icon: 'ecs-font-icon-ppl-user-consumers',
    advice: {
      mobileTitle: 'Personal',
      links: [{
        title: 'Getting a personal loan with no credit check',
        link: '/blogs/ask-experian/how-to-get-a-personal-loan-without-a-credit-check/',
        linkType: 'blog'
      }, {
        title: 'What to know before applying for a loan',
        link: '/blogs/ask-experian/personal-loans-what-to-know-before-you-apply/',
        linkType: 'blog'
      }, {
        title: 'What is a credit-builder loan?',
        link: '/blogs/ask-experian/what-is-a-credit-builder-loan/',
        linkType: 'blog'
      }, {
        title: 'Average personal loan debt',
        link: '/blogs/ask-experian/research/personal-loan-study/',
        linkType: 'blog'
      }, {
        title: 'APR vs. interest rate',
        link: '/blogs/ask-experian/apr-vs-interest-rate-whats-the-difference/',
        linkType: 'blog'
      }, {
        title: 'Reasons to get a personal loan',
        link: '/blogs/ask-experian/what-is-a-good-reason-to-get-a-personal-loan/',
        linkType: 'blog'
      }, {
        title: 'How to reduce your total loan cost',
        link: '/blogs/ask-experian/how-to-reduce-your-total-loan-cost/',
        linkType: 'blog'
      }, {
        title: 'Getting a personal loan with a cosigner',
        link: '/blogs/ask-experian/can-you-get-a-personal-loan-with-a-cosigner/',
        linkType: 'blog'
      }]
    }
  }]
}, {
  id: 'aut',
  tabName: 'Insurance',
  dataLinkBoth: 'nav-public-header-insurance',
  adviceTitle: 'Auto Insurance Advice',
  drpMainCategories: [{
    subcopy: 'Compare, switch and save',
    icon: 'ecs-font-icon-ccm-auto',
    link: '/insurance/car-insurance-quotes/',
    linkType: 'product',
    title: 'Auto insurance',
    advice: {
      mobileTitle: 'Most popular',
      links: [{
        title: 'Average cost of car insurance',
        link: '/blogs/ask-experian/average-cost-car-insurance/',
        linkType: 'blog'
      }, {
        title: 'Cheapest states for car insurance',
        link: '/blogs/ask-experian/cheapest-car-insurance/',
        linkType: 'blog'
      }, {
        title: 'Bundling home and auto insurance',
        link: '/blogs/ask-experian/should-you-bundle-your-home-and-auto-insurance/',
        linkType: 'blog'
      }, {
        title: 'Top car insurance discounts',
        link: '/blogs/ask-experian/top-car-insurance-discounts/',
        linkType: 'blog'
      }, {
        title: 'How to save on car insurance',
        link: '/blogs/ask-experian/how-to-save-on-auto-insurance/',
        linkType: 'blog'
      }, {
        title: 'Factors that impact car insurance rates',
        link: '/blogs/ask-experian/factors-that-determine-your-car-insurance-rates/',
        linkType: 'blog'
      }, {
        title: 'How accidents affect insurance',
        link: '/blogs/ask-experian/how-long-does-an-accident-stay-on-your-insurance/',
        linkType: 'blog'
      }, {
        title: 'Liability vs. full coverage car insurance',
        link: '/blogs/ask-experian/liability-vs-full-coverage-car-insurance/',
        linkType: 'blog'
      }]
    }
  }]
}];
export default menus;